var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardExec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "522px",
    height: "446px",
    viewBox: "0 0 522 446",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.522,12.575 C58.522,12.575 17.239,16.665 3.771,13.016 C1.206,12.321 -0.351,9.507 0.679,7.057 C1.225,5.758 2.456,4.65 5.186,3.883 C8.36,2.991 11.126,4.585 12.885,6.076 C13.628,6.705 14.731,6.33 15.023,5.401 C15.398,4.21 16.301,2.922 18.345,2.179 C21.373,1.077 25.666,3.624 28.191,5.445 C28.872,5.935 29.789,5.409 29.736,4.572 C29.594,2.296 30.481,-0.572 36.24,0.355 C41.932,1.272 44.233,4.555 45.162,6.926 C45.537,7.885 46.748,8.233 47.559,7.6 C48.969,6.498 51.14,5.612 53.773,7.184 C58.522,10.018 58.522,12.575 58.522,12.575",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50.0012815%",
    x2: "3.4506838e-05%",
    y2: "50.0012815%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.172,80.577 C0.172,80.577 -2.454,21.472 33.251,0.065 C76.684,24.967 56.273,77.628 56.273,77.628 L20.481,114.988 L0.172,80.577",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.904,36.448 C0.904,36.448 27.682,-5.044 60.168,1.636 C83.511,65.209 4.292,99.39 4.292,99.39 L0.904,36.448",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.408,78.167 C41.408,78.167 -7.429,44.48 2.03,2.056 C75.992,-9.051 86.718,63.718 86.718,63.718 L41.408,78.167",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.812,214.211 C145.812,108.244 145.812,19.528 145.812,19.528 C145.812,19.528 70.237,-13.331 0.416,7.205 C0.416,91.816 0.416,191.211 0.416,191.211 C0.416,191.211 115.419,195.318 145.812,214.211",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.9999998%",
    x2: "99.9993122%",
    y2: "49.9999998%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.69,19.528 C0.69,19.528 76.265,-13.331 146.086,7.205 C146.086,91.816 146.086,191.211 146.086,191.211 C146.086,191.211 31.084,195.318 0.69,214.211",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.784,33.173 C95.784,33.173 89.888,25.244 89.888,16.67 C89.888,8.095 95.457,1.194 95.457,1.194 L95.457,0.582 L17.641,0.582 C8.18,0.582 0.439,7.486 0.439,15.925 L0.439,18.636 C0.439,27.074 8.18,33.979 17.641,33.979 L95.457,33.979 L95.784,33.774 L95.784,33.173 L95.784,33.173 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-17",
    points: "0.696 23.063 16.542 6.818 25.664 1.942 33.328 0.803 0.696 23.063"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-5.84273106%",
    y1: "63.6213092%",
    x2: "103.64734%",
    y2: "32.7582572%",
    id: "linearGradient-19"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "path-20",
    points: "42.227 2.653 35.899 0.064 0.91 21.934 33.427 11.042 42.227 2.653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.868,8.085 C-0.406,13.623 12.654,14.335 18.035,14.395 C19.527,14.412 21.012,14.271 22.474,13.974 C27.025,13.05 36.986,10.627 35.589,7.332 C33.787,3.08 28.372,6.044 28.372,6.044 C28.372,6.044 29.051,2.835 19.838,0.715 C10.624,-1.405 10.661,5.659 10.661,5.659 C10.661,5.659 2.469,1.128 0.868,8.085",
    id: "path-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.000106984903%",
    y1: "49.9982269%",
    x2: "100.000393%",
    y2: "49.9982269%",
    id: "linearGradient-24"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.769,16.192 L50.371,16.192 C50.371,16.192 53.061,12.789 50.371,10.499 C48.887,9.235 47.133,9.366 45.86,9.738 C45.03,9.979 44.203,9.42 44.021,8.575 C43.72,7.176 42.79,5.345 40.12,4.263 C37.493,3.199 35.831,4.824 34.87,6.494 C34.554,7.043 33.712,6.961 33.521,6.356 C32.688,3.721 29.786,0.226 20.251,0.226 C8.125,0.226 9.472,6.673 10.556,9.352 C10.744,9.818 10.346,10.3 9.855,10.195 C7.984,9.795 4.512,9.277 2.956,10.499 C0.769,12.216 0.769,16.192 0.769,16.192",
    id: "path-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.00196859866%",
    y1: "50.0006263%",
    x2: "99.9985126%",
    y2: "50.0006263%",
    id: "linearGradient-27"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.73,16.828 C24.567,18.902 30.11,7.947 30.11,7.947 C30.11,7.947 29.81,10.233 30.739,13.618 C34.05,9.322 31.886,3.91 31.886,3.91 C31.886,3.91 29.208,-2.004 17.271,0.894 C3.354,4.272 1.034,23.395 1.034,23.395 C1.034,23.395 0.016,27.559 3.6,34.233 C4.612,36.118 4.556,38.441 3.254,40.139 C0.275,44.027 1.034,48.824 1.034,48.824 C1.034,48.824 1.325,51.324 3.46,52.961 C5.456,54.492 6.261,57.772 5.461,60.156 C3.747,65.26 5.209,68.165 5.209,68.165 C5.209,68.165 6.141,71.444 11.24,71.645 C18.675,71.937 18.518,66.032 17.848,62.705 C17.593,61.439 17.924,60.13 18.786,59.17 C19.698,58.155 20.689,56.568 20.751,54.43 C20.803,52.625 20.1,50.716 19.31,49.163 C18.287,47.15 18.463,44.754 19.802,42.937 C21.702,40.358 24.152,35.228 22.78,31.9 C20.46,26.277 16.499,24.4 14.73,16.828",
    id: "path-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.0022453%",
    x2: "100.000269%",
    y2: "50.0022453%",
    id: "linearGradient-30"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.77,35.825 C49.77,35.825 46.844,31.345 45.813,30.139 C42.07,26.268 49.118,7.513 44.571,4.512 C40.024,1.511 7.186,-2.24 3.6,4.512 C0.013,11.264 -1.806,32.142 4.863,35.058 C11.532,37.974 37.796,35.892 40.706,34.944 C45.594,33.353 49.77,35.825 49.77,35.825",
    id: "path-31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.000626271972%",
    y1: "50.0005653%",
    x2: "100.00081%",
    y2: "50.0005653%",
    id: "linearGradient-33"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.234,2.271 C3.175,4.583 -0.082,12.373 0.964,18.685 C1.12,19.624 1.659,20.474 2.48,20.956 C9.402,25.009 18.942,26.366 22.242,26.73 C23.046,26.818 23.84,26.548 24.422,25.987 C26.424,24.056 30.852,18.637 32.289,7.481 C32.382,6.758 32.129,6.021 31.614,5.504 C25.45,-0.67 8.206,-0.032 5.235,1.275 C4.789,1.472 4.438,1.827 4.234,2.271",
    id: "path-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92,13.889 C4.775,16.645 2.686,21.631 1.885,27.342 C0.015,40.671 -0.85,64.883 6.064,71.537 C13.145,78.35 31.971,67.514 43.122,61.178 C47.517,58.682 50.558,54.412 51.491,49.503 C54.347,34.478 59.172,2.319 48.508,0.764 C38.927,-0.633 20.504,8.217 9.92,13.889",
    id: "path-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.491,14.667 C2.627,13.894 1.98,12.027 1.523,11.388 C-1.417,7.267 2.48,5.727 3.845,5.254 C5.354,4.732 5.671,2.301 7.683,1.388 C10.754,-0.006 12.734,2.69 14.462,2.785 C16.188,2.879 17.748,0.93 19.869,2.677 C21.991,4.425 21.269,6.248 21.846,7.23 C22.424,8.213 24.372,6.356 26.107,9.438 C28.747,14.126 21.356,14.067 21.356,14.067 C21.356,14.067 17.145,14.724 12.559,11.507 C11.931,11.066 11.068,11.017 10.481,11.513 C8.871,12.873 6.757,21.533 6.757,21.533 L5.407,19.717 C5.407,19.717 1.87,18.21 2.491,14.667",
    id: "path-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.91,26.691 C25.269,20.554 32.502,23.655 36.259,21.955 C42.476,19.144 45.88,-0.098 56.906,0.938 C67.933,1.974 67.933,9.375 67.933,9.375 C67.933,9.375 70.385,15.697 55.168,14.247 C52.729,14.014 49.649,15.295 49.591,17.744 C49.446,23.884 49.679,29.208 49.679,29.208 C49.679,29.208 38.331,32.76 34.039,36.757 C29.747,40.753 21.902,61.179 9.321,61.178 C-2.52,60.142 -4.444,36.608 13.91,26.691",
    id: "path-40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68,0.545 C-3.636,0.545 1.602,24.188 1.602,24.188 C1.602,24.188 3.796,39.523 8.68,45.681 C12.907,51.011 21.271,49.408 25.232,46.849 C27.169,45.599 29.339,44.765 31.627,44.489 C34.982,44.085 38.974,42.604 38.974,36.55 C38.974,30.853 32.172,26.446 27.695,23.298 C24.777,21.247 22.742,18.18 21.892,14.716 C20.459,8.882 16.963,0.545 8.68,0.545",
    id: "path-42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.767,36.764 C11.749,52.869 38.848,94.598 66.691,120.18 C69.036,122.334 72.353,123.06 75.389,122.098 C102.768,113.42 152.91,91.322 152.91,91.322 C156.697679,89.841 157.918,85.083 155.313,81.961 L89.729,3.353 C87.923,1.188 84.969,0.359 82.3,1.271 L5.026,27.645 C1.261,28.93 -0.33,33.382 1.767,36.764",
    id: "path-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.000311083963%",
    y1: "49.9998052%",
    x2: "99.9995645%",
    y2: "49.9998052%",
    id: "linearGradient-46"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "path-47",
    points: "1.875 7.019 0.037 0.376 30.302 5.641 1.875 7.019"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.44738146%",
    y1: "45.8675716%",
    x2: "87.6140757%",
    y2: "56.2085785%",
    id: "linearGradient-49"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "path-50",
    points: "25.302 0.641 0.405 7.271 3.64 16.873 25.302 0.641"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MD-/-Vector-/-Books",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shutterstock_1039074907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(388.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.522,12.575 C58.522,12.575 17.239,16.665 3.771,13.016 C1.206,12.321 -0.351,9.507 0.679,7.057 C1.225,5.758 2.456,4.65 5.186,3.883 C8.36,2.991 11.126,4.585 12.885,6.076 C13.628,6.705 14.731,6.33 15.023,5.401 C15.398,4.21 16.301,2.922 18.345,2.179 C21.373,1.077 25.666,3.624 28.191,5.445 C28.872,5.935 29.789,5.409 29.736,4.572 C29.594,2.296 30.481,-0.572 36.24,0.355 C41.932,1.272 44.233,4.555 45.162,6.926 C45.537,7.885 46.748,8.233 47.559,7.6 C48.969,6.498 51.14,5.612 53.773,7.184 C58.522,10.018 58.522,12.575 58.522,12.575",
    id: "Fill-2",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M350.172,80.577 C350.172,80.577 347.546,21.472 383.251,0.065 C426.684,24.967 406.273,77.628 406.273,77.628 L370.481,114.988 L350.172,80.577",
    id: "Fill-5",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(350.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-6",
    fill: "#005C5A",
    mask: "url(#mask-5)",
    points: "61.528 54.82 25.05 78.686 30.369 30.815 51.274 16.165 50.527 15.098 30.561 29.09 33.854 -0.557 32.492 -0.091 26.457 54.222 5.642 37.023 5.602 38.681 26.285 55.77 19.571 116.192 20.866 116.336 24.863 80.364 61.158 56.618 61.528 54.82"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M372.904,97.448 C372.904,97.448 399.682,55.956 432.168,62.636 C455.511,126.209 376.292,160.39 376.292,160.39 L372.904,97.448",
    id: "Fill-9",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.904,97.448 C372.904,97.448 399.682,55.956 432.168,62.636 C455.511,126.209 376.292,160.39 376.292,160.39 L372.904,97.448",
    id: "Fill-10",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(372.000000, 61.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-11",
    fill: "#1B2441",
    mask: "url(#mask-7)",
    points: "57.122 54.711 19.947 55.603 60.686 2.03 59.648 1.242 34.923 33.755 31.345 6.389 30.178 7.512 33.802 35.23 0.262 79.336 1.3 80.125 18.938 56.931 55.971 56.042 57.122 54.711"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M345.408,102.167 C345.408,102.167 296.571,68.48 306.03,26.056 C379.992,14.949 390.718,87.718 390.718,87.718 L345.408,102.167",
    id: "Fill-14",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(304.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-16"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-15",
    fill: "#FFFFFE",
    mask: "url(#mask-9)",
    points: "55.962 11.689 54.748 10.968 48.601 54.755 2.522 1.629 1.539 2.482 34.226 40.167 8.605 43.402 9.906 44.551 35.252 41.351 61.783 71.94 63.396 71.813 49.732 56.06 55.962 11.689"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413.264,94.35 C421.153,99.576 415.56,170.63 412.969,225.74 C411.421,258.661 413.264,288.211 413.264,288.211 L243.858,288.211 L331.032,93.072 C331.032,93.072 400.66,86.001 413.264,94.35",
    id: "Fill-18",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.24,94.35 C75.153,99.747 81.588,179.191 84.475,234.685 C86.053,265.028 84.043,288.211 84.043,288.211 L247.009,288.211 L163.222,93.072 C163.222,93.072 93.203,86.001 82.24,94.35",
    id: "Fill-19",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.896,265.636 L110.896,275.067 C110.896,275.067 169.998,272.399 247.009,288.211 C238.629,270.134 222.983,249.191 116.799,249.191 C101.614,246.729 110.896,265.636 110.896,265.636",
    id: "Fill-20",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.41,265.636 L386.41,275.067 C386.41,275.067 321.899,272.399 244.888,288.211 C253.269,270.134 274.323,249.191 380.507,249.191 C395.691,246.729 386.41,265.636 386.41,265.636",
    id: "Fill-21",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(103.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.812,214.211 C145.812,108.244 145.812,19.528 145.812,19.528 C145.812,19.528 70.237,-13.331 0.416,7.205 C0.416,91.816 0.416,191.211 0.416,191.211 C0.416,191.211 115.419,195.318 145.812,214.211",
    id: "Fill-22",
    fill: "url(#linearGradient-12)",
    mask: "url(#mask-11)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(246.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.69,19.528 C0.69,19.528 76.265,-13.331 146.086,7.205 C146.086,91.816 146.086,191.211 146.086,191.211 C146.086,191.211 31.084,195.318 0.69,214.211",
    id: "Fill-25",
    fill: "url(#linearGradient-12)",
    mask: "url(#mask-14)"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-28",
    fill: "#FFFFFE",
    points: "130.855 93.556 132.812 112.758 229.03 117.949 227.093 103.222 130.855 93.556"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-29",
    fill: "#FFFFFE",
    points: "128.865 153.764 128.865 214.591 224.117 209.106 220.906 160.633 128.865 153.764"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-30",
    fill: "#FFFFFE",
    points: "126.57 124.744 126.57 137.328 228.73 144.234 227.206 128.362 126.57 124.744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.4,134.713 C111.4,134.713 150.831,121.72 160.74,103.101 C165.515,94.129 158.739,83.65 148.578,83.849 C118.871,84.429 107.933,131.611 107.933,131.611 L111.4,134.713",
    id: "Fill-31",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.457,137.328 L107.408,136.71 C108.495,134.866 133.931,91.575 158.842,88.188 L159.71,89.239 C135.382,92.546 108.72,136.882 108.457,137.328",
    id: "Fill-32",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.122,104.129 C76.396,97.812 73.649,92.195 72.186,87.324 C68.216,74.105 77.069,60.367 90.676,58.052 C98.31,56.754 107.728,58.01 116.585,66.991 C136.052,86.729 109.825,140.612 109.825,140.612 L100.362,140.612 C100.362,140.612 100.004,129.371 81.122,104.129",
    id: "Fill-33",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.817,140.612 C89.817,140.612 62.221,134.599 57.215,113.483 C55.658,106.916 61.021,100.684 67.762,101.028 C101.936,102.77 100.362,140.612 100.362,140.612 L89.817,140.612",
    id: "Fill-34",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.74,140.75 L103.555,140.474 C103.682,139.931 115.551,85.639 85.342,59.629 L86.653,59.111 C117.42,85.603 104.868,140.199 104.74,140.75",
    id: "Fill-35",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.851,140.919 C95.661,140.596 76.496,108.626 58.009,106.725 L58.694,105.56 C77.796,107.524 96.117,138.966 96.901,140.305 L95.851,140.919",
    id: "Fill-36",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-37",
    fill: "#13374D",
    points: "83.598 174.061 118.813 174.061 118.813 140.612 83.598 140.612"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.342,144.86 L81.092,144.86 C79.753,144.86 78.658,143.765 78.658,142.427 C78.658,141.088 79.753,139.993 81.092,139.993 L121.342,139.993 C122.681,139.993 123.776,141.088 123.776,142.427 C123.776,143.765 122.681,144.86 121.342,144.86",
    id: "Fill-38",
    fill: "#A0D2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.699,305.303 C152.901,302.403 17.059,305.303 17.059,305.303 C10.085,305.303 3.682,313.101 3.682,320.074 C3.682,327.049 10.085,334.847 17.059,334.847 C17.059,334.847 149.879,340.428 160.767,335.007 C158.908,323.155 159.176,312.42 160.699,305.303",
    id: "Fill-39",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-40",
    fill: "#5BBDB7",
    points: "6.645 308.703 159.896 308.703 159.896 308.006 6.645 308.006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.655,312.42 L4.107,312.42 L4.107,313.117 L159.493,313.117 C159.536,312.879 159.593,312.648 159.655,312.42",
    id: "Fill-41",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-42",
    fill: "#5BBDB7",
    points: "2.151 319.394 159.313 319.394 159.313 318.696 2.151 318.696"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-43",
    fill: "#5BBDB7",
    points: "2.151 322.531 159.313 322.531 159.313 321.834 2.151 321.834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.752,326.889 L3.644,326.889 L3.644,327.586 L159.853,327.586 C159.81,327.354 159.775,327.122 159.752,326.889",
    id: "Fill-44",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.518,332.99 L7.755,332.99 C7.91,333.216 8.055,333.449 8.191,333.688 L160.658,333.688 C160.601,333.456 160.557,333.224 160.518,332.99",
    id: "Fill-45",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.059,334.847 C10.085,334.847 3.682,327.049 3.682,320.074 C3.682,313.101 10.085,305.303 17.059,305.303 C17.059,305.303 152.362,302.415 160.646,305.285 C160.995,303.468 161.269,302.403 161.269,302.403 L17.867,302.403 C8.148,302.403 0.196,310.355 0.196,320.074 C0.196,329.794 8.148,337.746 17.867,337.746 C17.867,337.746 154.295,340.893 161.269,337.746 C161.269,337.479 161.046,336.501 160.747,335.016 C149.729,340.421 17.059,334.847 17.059,334.847",
    id: "Fill-46",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.775,302.955 L19.725,302.955 C14.495,302.955 10.215,298.675 10.215,293.444 L10.215,272.234 C10.215,267.004 14.495,262.725 19.725,262.725 L141.775,262.725 C147.006,262.725 151.286,267.004 151.286,272.234 L151.286,293.444 C151.286,298.675 147.006,302.955 141.775,302.955",
    id: "Fill-47",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.019,262.725 C23.292,282.84 31.878,302.955 31.878,302.955 L49.578,302.955 C49.578,302.955 43.105,279.966 50.634,262.725 C41.916,262.725 36.765,262.725 31.019,262.725",
    id: "Fill-48",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.046,262.725 C105.319,282.84 113.905,302.955 113.905,302.955 L131.605,302.955 C131.605,302.955 125.132,279.966 132.661,262.725 C123.943,262.725 118.792,262.725 113.046,262.725",
    id: "Fill-49",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.784,261.173 C145.784,261.173 139.888,253.244 139.888,244.67 C139.888,236.095 145.457,229.194 145.457,229.194 L145.457,228.582 L67.641,228.582 C58.18,228.582 50.439,235.486 50.439,243.925 L50.439,246.636 C50.439,255.074 58.18,261.979 67.641,261.979 L145.457,261.979 L145.784,261.774 L145.784,261.173",
    id: "Fill-50",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-59",
    transform: "translate(50.000000, 228.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-52"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-51",
    fill: "#5BBDB7",
    mask: "url(#mask-16)",
    points: "21.897 4.831 95.784 4.831 95.784 4.134 21.897 4.134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.907,8.548 L19.359,8.548 L19.359,9.245 L174.745,9.245 C174.788,9.007 174.845,8.776 174.907,8.548",
    id: "Fill-53",
    fill: "#5BBDB7",
    mask: "url(#mask-16)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-54",
    fill: "#5BBDB7",
    mask: "url(#mask-16)",
    points: "17.403 15.521 95.784 15.521 95.784 14.823 17.403 14.823"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-55",
    fill: "#5BBDB7",
    mask: "url(#mask-16)",
    points: "17.403 18.658 95.784 18.658 95.784 17.961 17.403 17.961"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-56",
    fill: "#5BBDB7",
    mask: "url(#mask-16)",
    points: "22.754 21.796 95.784 21.796 95.784 21.099 22.754 21.099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.764,25.513 L20.216,25.513 L20.216,26.21 L175.602,26.21 C175.645,25.972 175.702,25.741 175.764,25.513",
    id: "Fill-57",
    fill: "#5BBDB7",
    mask: "url(#mask-16)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-58",
    fill: "#5BBDB7",
    mask: "url(#mask-16)",
    points: "18.26 30.52 95.784 30.52 95.784 29.822 18.26 29.822"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.737,228.916 L146.276,228.916 L146.276,226.266 L87.791,226.266 L87.791,228.916 L97.393,228.916 C96.388,237.054 94.044,245.728 91.438,253.357 C91.31,254.247 91.16,255.133 91.066,256.03 C91.01,256.569 90.978,257.107 90.949,257.646 C92.281,258.67 93.442,259.816 94.438,261.057 L87.791,261.057 L87.791,263.707 L146.276,263.707 L146.276,261.057 L111.786,261.057 C107.164,261.057 102.878,258.455 100.848,254.256 C99.21,250.871 98.367,247.094 98.504,243.484 C98.584,241.358 99.011,239.388 99.72,237.585 C101.811,232.264 107.075,228.916 112.737,228.916",
    id: "Fill-60",
    fill: "#E98333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.654,246.506 L95.654,243.467 C95.654,234.006 103.395,226.266 112.856,226.266 L30.289,226.266 C20.829,226.266 13.088,234.006 13.088,243.467 L13.088,246.506 C13.088,255.967 20.829,263.707 30.289,263.707 L112.856,263.707 C103.395,263.707 95.654,255.967 95.654,246.506",
    id: "Fill-61",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-62",
    fill: "#FFFFFE",
    points: "33.565 263.707 37.251 263.707 37.251 226.266 33.565 226.266"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-63",
    fill: "#A0D2BB",
    points: "40.119 263.707 41.962 263.707 41.962 226.266 40.119 226.266"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-66",
    transform: "translate(45.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-65"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-64",
    fill: "url(#linearGradient-19)",
    mask: "url(#mask-18)",
    points: "0.696 23.063 16.542 6.818 25.664 1.942 33.328 0.803 0.696 23.063"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-67",
    fill: "#A0D2BB",
    points: "45.696 41.063 78.542 21.145 78.328 18.803"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-68",
    fill: "#5BBDB7",
    points: "81.405 26.948 81.382 27.036 81.559 33.017 45.787 41.038 81.405 26.948"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-71",
    transform: "translate(45.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-21",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-70"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-69",
    mask: "url(#mask-21)",
    points: "42.227 2.653 35.899 0.064 0.91 21.934 33.427 11.042 42.227 2.653"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.659,68.002 C187.371,67.944 186.067,67.792 184.783,67.551 C184.489,67.496 184.208,67.689 184.152,67.982 C184.097,68.276 184.29,68.558 184.584,68.613 C185.916,68.864 187.271,69.021 188.61,69.082 C189.095,69.104 189.578,69.114 190.061,69.113 C190.238,69.114 190.396,69.028 190.494,68.896 C190.562,68.805 190.602,68.693 190.601018,68.572 C190.601018,68.273 190.357,68.032 190.06,68.033 C189.593,68.033 189.126,68.022 188.659,68.002",
    id: "Fill-72",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.468,14.652 C94.916,15.347 93.315,16.121 91.575,17.018 C91.31,17.155 91.207,17.48 91.342,17.746 C91.479,18.011 91.805,18.116 92.07,17.979 C93.792,17.091 95.376,16.325 96.91,15.639 C96.997,15.6 97.068,15.54 97.122,15.468 C97.235,15.316 97.265,15.109 97.182,14.924 C97.06,14.652 96.74,14.53 96.468,14.652",
    id: "Fill-73",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.217,12.44 C105.315,12.309 105.352,12.135 105.303,11.965 C105.218,11.679 104.918,11.515 104.631,11.599 C102.967,12.085 101.232,12.685 99.477,13.38 C99.2,13.49 99.063,13.805 99.174,14.081 C99.284,14.359 99.598,14.496 99.875,14.385 C101.6,13.703 103.302,13.114 104.936,12.636 C105.052,12.602 105.149,12.531 105.217,12.44",
    id: "Fill-74",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.79,64.782 C176.525,64.644 176.197,64.739 176.062,65.012 C175.924,65.277 176.026,65.603 176.292,65.74 C177.916,66.586 179.627,67.288 181.377,67.823 C181.601,67.892 181.837,67.807 181.969,67.629 C182.005,67.581 182.034,67.526 182.052,67.465 C182.14,67.18 181.979,66.877 181.694,66.79 C180.007,66.273 178.357,65.597 176.79,64.782",
    id: "Fill-75",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.199,63.912 C174.366,63.663 174.299,63.328 174.051,63.161 C173.65,62.893 173.256,62.615 172.87,62.327 C171.834,61.556 170.849,60.712 169.943,59.819 C169.73,59.609 169.388,59.612 169.179,59.824 C168.976,60.034 168.971,60.38 169.184,60.589 C170.125,61.518 171.149,62.394 172.224,63.194 C172.625,63.493 173.034,63.781 173.45,64.059 C173.689,64.22 174.012,64.163 174.184,63.933 C174.189,63.926 174.194,63.919 174.199,63.912",
    id: "Fill-76",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.727,58.222 C167.762,58.193 167.793,58.161 167.819,58.126 C167.963,57.932 167.964,57.658 167.804,57.462 C166.739,56.155 165.745,54.727 164.766,53.095 C164.613,52.839 164.28,52.756 164.025,52.909 C163.771,53.062 163.686,53.395 163.839,53.65 C164.845,55.328 165.868,56.798 166.967,58.145 C167.155,58.376 167.496,58.411 167.727,58.222",
    id: "Fill-77",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.666,18.221 C141.255,18.616 141.835,19.026 142.405,19.449 C143.264,20.089 144.104,20.766 144.902,21.461 C145.127,21.658 145.468,21.634 145.665,21.409 C145.674,21.398 145.682,21.388 145.691,21.376 C145.857,21.152 145.827,20.833 145.612,20.647 C144.793,19.933 143.932,19.238 143.05,18.582 C142.467,18.148 141.872,17.727 141.267,17.323 C141.019,17.157 140.69,17.189 140.517,17.471 C140.351,17.719 140.417,18.054 140.666,18.221",
    id: "Fill-78",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.229,23.657 C148.479,24.933 149.644,26.295 150.691,27.706 C150.869,27.946 151.208,27.995 151.448,27.817 C151.491,27.785 151.528,27.748 151.559,27.706 C151.698,27.52 151.705,27.257 151.559,27.061 C150.482,25.611 149.286,24.211 148.002,22.9 C147.793,22.686 147.451,22.683 147.238,22.892 C147.027,23.097 147.02,23.443 147.229,23.657",
    id: "Fill-79",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.144,14.198 C134.788,14.881 136.401,15.669 137.94,16.54 C138.18,16.677 138.479,16.609 138.64,16.394 C138.653,16.375 138.666,16.356 138.677,16.336 C138.824,16.077 138.732,15.747 138.473,15.6 C136.896,14.706 135.242,13.899 133.56,13.2 C133.284,13.085 132.966,13.213 132.853,13.492 C132.738,13.767 132.869,14.083 133.144,14.198",
    id: "Fill-80",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.826,11.193 C122.026,11.218 122.213,11.13 122.326,10.979 C122.38,10.907 122.417,10.819 122.429,10.723 C122.465,10.427 122.254,10.157 121.958,10.121 C120.141,9.896 118.304,9.787 116.497,9.797 C116.197,9.8 115.958,10.043 115.958997,10.34 C115.961,10.639 116.205,10.879 116.503,10.878 C118.263,10.868 120.054,10.975 121.826,11.193",
    id: "Fill-81",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.315,43.182 C159.406,43.143 159.48,43.082 159.535,43.008 C159.646,42.859 159.677,42.655 159.597,42.472 L159.327,41.843 C158.703,40.394 158.078,38.945 157.428,37.509 C157.304,37.237 156.984,37.117 156.712,37.24 C156.44,37.364 156.32,37.683 156.443,37.956 C157.09,39.385 157.712,40.829 158.334,42.271 L158.605,42.899 C158.723,43.174 159.041,43.3 159.315,43.182",
    id: "Fill-82",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.144,13.077 C130.371,13.153 130.612,13.069 130.748,12.887 C130.781,12.842 130.808,12.791 130.827,12.734 C130.921,12.451 130.768,12.145 130.484,12.051 C128.753,11.476 126.975,11.004 125.199,10.646 C124.906,10.589 124.624,10.779 124.563,11.07 C124.504,11.363 124.693,11.648 124.986,11.707 C126.719,12.055 128.454,12.516 130.144,13.077",
    id: "Fill-83",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.458,63.623 C252.17,63.549 251.875,63.722 251.802,64.014 C251.728,64.304 251.903,64.597 252.192,64.67 L257.432,66 C257.65,66.056 257.872,65.969 257.999,65.799 C258.039,65.744 258.07,65.681 258.088,65.609 C258.162,65.319 257.987,65.026 257.698,64.953 L252.458,63.623",
    id: "Fill-84",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.052,61.539 C243.761,61.471 243.473,61.655 243.403,61.945 C243.336,62.236 243.519,62.525 243.809,62.593 C245.563,62.996 247.311,63.434 249.05,63.873 C249.268,63.929 249.489,63.842 249.616,63.672 C249.657,63.617 249.688,63.553 249.706,63.481 C249.779,63.192 249.604,62.899 249.314,62.825 C247.569,62.383 245.814,61.945 244.052,61.539",
    id: "Fill-85",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.496,59.956 C235.197,59.917 234.928,60.129 234.892,60.424 C234.854,60.72 235.064,60.991 235.36,61.029 C237.008,61.236 238.738,61.524 240.652,61.908 C240.864,61.95 241.072,61.862 241.192,61.701 C241.239,61.638 241.272,61.565 241.289,61.484 C241.348,61.191 241.158,60.906 240.865,60.848 C238.925,60.459 237.169,60.166 235.496,59.956",
    id: "Fill-86",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.841,65.75 C260.552,65.676 260.258,65.849 260.185,66.141 C260.11,66.431 260.285,66.724 260.574,66.797 L265.814,68.127 C266.033,68.183 266.254,68.096 266.381,67.926 C266.422,67.871 266.453,67.808 266.471,67.736 C266.545,67.447 266.369,67.153 266.08,67.08 L260.841,65.75",
    id: "Fill-87",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.18,45.165 C159.905,45.289 159.784,45.604 159.906,45.879 C160.769,47.817 161.513,49.377 162.246,50.789 C162.384,51.053 162.709,51.156 162.975,51.018 C163.05,50.979 163.112,50.925 163.159,50.862 C163.279,50.701 163.304,50.48 163.206,50.29 C162.483,48.898 161.748,47.357 160.893,45.439 C160.771,45.166 160.452,45.044 160.18,45.165",
    id: "Fill-88",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.767,59.62 C226.471,59.638 226.243,59.897 226.261,60.193 C226.279,60.492 226.536,60.718 226.834,60.699 C228.549,60.592 230.294,60.599 232.166,60.721 C232.356,60.734 232.53,60.645 232.635,60.504 C232.696,60.423 232.733,60.325 232.741,60.217 C232.760003,59.919 232.534,59.662 232.237,59.642 C230.317,59.518 228.528,59.51 226.767,59.62",
    id: "Fill-89",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.403,69.191 L269.225,67.878 C268.936,67.803 268.641,67.977 268.567,68.268 C268.494,68.558 268.669,68.852 268.958,68.925 L274.138,70.239 C274.356,70.295 274.577,70.208 274.704,70.038 C274.745,69.983 274.776,69.919 274.794,69.848 C274.867,69.558 274.692,69.265 274.403,69.191",
    id: "Fill-90",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.243,67.866 C192.947,67.896 192.729,68.16 192.759,68.457 C192.788,68.754 193.053,68.971 193.35,68.941 C195.06,68.772 196.823,68.479 198.743,68.044 C198.874,68.014 198.982,67.939 199.057,67.839 C199.147,67.717 199.187,67.557 199.15,67.396 C199.084,67.105 198.795,66.923 198.503,66.989 C196.629,67.414 194.908,67.7 193.243,67.866",
    id: "Fill-91",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.66,29.608 C152.409,29.767 152.328,30.099 152.486,30.352 C153.354,31.751 154.199,33.284 155.067,35.039 C155.199,35.307 155.524,35.416 155.791,35.284 C155.871,35.245 155.936,35.189 155.985,35.122 C156.103,34.965 156.13,34.748 156.036,34.56 C155.152,32.773 154.292,31.21 153.404,29.783 C153.247,29.529 152.914,29.451 152.66,29.608",
    id: "Fill-92",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.151,61.068 C217.861,61.141 217.688,61.436 217.762,61.726 C217.836,62.015 218.13,62.19 218.419,62.115 C220.302,61.632 222.013,61.279 223.655,61.036 C223.803,61.015 223.928,60.935 224.01,60.824 C224.093,60.713 224.133,60.571 224.111,60.423 C224.067,60.127 223.793,59.923 223.499,59.967 C221.818,60.215 220.069,60.576 218.151,61.068",
    id: "Fill-93",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.673,10.41 C109.047,10.52 108.425,10.645 107.806,10.782 C107.516,10.846 107.33,11.134 107.395,11.426 C107.459,11.718 107.748,11.902 108.04,11.837 C108.644,11.703 109.25,11.582 109.862,11.474 C110.994,11.273 112.153,11.121 113.307,11.023 C113.467,11.009 113.606,10.927 113.695,10.808 C113.771,10.705 113.811,10.576 113.799,10.439 C113.774,10.142 113.513,9.92 113.215,9.946 C112.029,10.047 110.837,10.204 109.673,10.41",
    id: "Fill-94",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.618,66.197 C201.334,66.277 201.164,66.574 201.244,66.863 C201.323,67.15 201.622,67.319 201.91,67.238 C203.794,66.711 205.673,66.109 207.098,65.645 C207.209,65.609 207.299,65.541 207.364,65.454 C207.465,65.318 207.501,65.137 207.445,64.963 C207.352,64.68 207.046,64.524 206.763,64.617 C205.348,65.079 203.484,65.677 201.618,66.197",
    id: "Fill-95",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.842,63.598 C209.559,63.692 209.404,63.997 209.499,64.281 C209.592,64.565 209.898,64.718 210.181,64.625 C211.737,64.109 213.545,63.514 215.315,62.983 C215.431,62.948 215.526,62.878 215.594,62.788 C215.692,62.656 215.729,62.48 215.679,62.31 C215.593,62.023 215.291,61.862 215.005,61.947 C213.221,62.482 211.404,63.08 209.842,63.598",
    id: "Fill-96",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-99",
    transform: "translate(19.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-23",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.868,8.085 C-0.406,13.623 12.654,14.335 18.035,14.395 C19.527,14.412 21.012,14.271 22.474,13.974 C27.025,13.05 36.986,10.627 35.589,7.332 C33.787,3.08 28.372,6.044 28.372,6.044 C28.372,6.044 29.051,2.835 19.838,0.715 C10.624,-1.405 10.661,5.659 10.661,5.659 C10.661,5.659 2.469,1.128 0.868,8.085",
    id: "Fill-97",
    fill: "url(#linearGradient-24)",
    mask: "url(#mask-23)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.288,30.664 C180.043,34.124 185.887,44.453 187.582,45.456 C189.276,46.46 200.833,44.006 203.069,39.461 C205.304,34.915 201.401,25.368 198.417,23.681 C195.433,21.994 184.532,27.205 182.288,30.664",
    id: "Fill-100",
    fill: "#A0D2BB"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-101",
    fill: "#FFFFFE",
    points: "190.559 32.881 192.625 37.254 195.059 33.117 190.559 32.881"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-104",
    transform: "translate(234.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-103"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.769,16.192 L50.371,16.192 C50.371,16.192 53.061,12.789 50.371,10.499 C48.887,9.235 47.133,9.366 45.86,9.738 C45.03,9.979 44.203,9.42 44.021,8.575 C43.72,7.176 42.79,5.345 40.12,4.263 C37.493,3.199 35.831,4.824 34.87,6.494 C34.554,7.043 33.712,6.961 33.521,6.356 C32.688,3.721 29.786,0.226 20.251,0.226 C8.125,0.226 9.472,6.673 10.556,9.352 C10.744,9.818 10.346,10.3 9.855,10.195 C7.984,9.795 4.512,9.277 2.956,10.499 C0.769,12.216 0.769,16.192 0.769,16.192",
    id: "Fill-102",
    fill: "url(#linearGradient-27)",
    mask: "url(#mask-26)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.962,163.412 L95.022,163.416 C99.751,163.418 104.034,166.207 105.951,170.529 L110.763,181.381 L100.749,186.175 L103.958,188.34 L105.737,204.81 L69.008,204.191 L67.617,163.171 L89.768,163.659 L89.962,163.412",
    id: "Fill-105",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.942,155.091 C85.942,155.091 86.406,160.04 87.096,162.127 C87.638,163.616 89.962,163.412 89.962,163.412 C89.962,163.412 88.175,171.251 81.612,171.251 C75.049,171.251 74.034,164.524 74.034,164.524 L78.694,163.807 L76.542,156.646 L85.942,155.091",
    id: "Fill-106",
    fill: "#EC967C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.603,144.124 L87.102,135.272 L71.792,142.101 L72.72,147.281 C72.72,147.281 73.903,159.9 82.053,158.398 C90.868,156.775 88.996,144.011 88.603,144.124",
    id: "Fill-107",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.763,181.381 L112.83,188.713 C114.338,194.063 112.729,199.806 108.66,203.592 L99.28,211.459 L96.265,202.655 L101.453,197.46 C103.157,195.754 103.664,193.189 102.739,190.963 L100.749,186.175 L110.763,181.381",
    id: "Fill-108",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.715,183.282 L59.567,186.848 C57.474,193.347 59.087,200.471 63.777,205.433 L69.472,211.459 L72.411,197.371 L64.291,183.282 L60.715,183.282",
    id: "Fill-109",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-110",
    fill: "#5BBDB7",
    points: "59.567 186.848 64.678 189.809 65.538 181.332 60.967 181.332 59.567 186.848"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-113",
    transform: "translate(58.000000, 131.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-29",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.73,16.828 C24.567,18.902 30.11,7.947 30.11,7.947 C30.11,7.947 29.81,10.233 30.739,13.618 C34.05,9.322 31.886,3.91 31.886,3.91 C31.886,3.91 29.208,-2.004 17.271,0.894 C3.354,4.272 1.034,23.395 1.034,23.395 C1.034,23.395 0.016,27.559 3.6,34.233 C4.612,36.118 4.556,38.441 3.254,40.139 C0.275,44.027 1.034,48.824 1.034,48.824 C1.034,48.824 1.325,51.324 3.46,52.961 C5.456,54.492 6.261,57.772 5.461,60.156 C3.747,65.26 5.209,68.165 5.209,68.165 C5.209,68.165 6.141,71.444 11.24,71.645 C18.675,71.937 18.518,66.032 17.848,62.705 C17.593,61.439 17.924,60.13 18.786,59.17 C19.698,58.155 20.689,56.568 20.751,54.43 C20.803,52.625 20.1,50.716 19.31,49.163 C18.287,47.15 18.463,44.754 19.802,42.937 C21.702,40.358 24.152,35.228 22.78,31.9 C20.46,26.277 16.499,24.4 14.73,16.828",
    id: "Fill-111",
    fill: "#1B2441",
    mask: "url(#mask-29)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-114",
    fill: "url(#linearGradient-30)",
    points: "67.617 213.663 104.826 213.663 104.826 191.394 67.617 191.394"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-116",
    fill: "#BAA6B7",
    points: "67.617 214.591 104.826 214.591 104.826 212.735 67.617 212.735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.733,200.479 C84.733,201.301 85.399,201.968 86.221,201.968 C87.043,201.968 87.709,201.301 87.709,200.479 C87.709,199.657 87.043,198.991 86.221,198.991 C85.399,198.991 84.733,199.657 84.733,200.479",
    id: "Fill-117",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.462,207.721 C136.257,222.13 72.669,228.572 72.669,228.572 L71.15,220.429 C71.15,220.429 126.668,193.312 131.462,207.721",
    id: "Fill-118",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-119",
    fill: "#F0AB85",
    points: "68.827 228.544 59.706 229.089 57.98 227.191 58.856 223.754 67.477 222.511 68.827 228.544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.706,223.631 L50.428,222.511 C50.428,222.511 46.833,221.567 43.625,222.091 L43.625,230.512 C46.028,230.79 48.417,230.48 48.417,230.48 L59.706,229.089 L59.579,228.896 C58.54,227.323 58.591,225.149 59.706,223.631",
    id: "Fill-120",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.907,225.8 C39.529,223.42 41.518,222.424 43.672,222.083 L43.672,230.517 C40.877,230.203 38.043,229.103 38.907,225.8",
    id: "Fill-121",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.69,
    y1: 224.247,
    x2: 54.69,
    y2: 227.871,
    id: "Fill-122",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-123",
    fill: "#FFFFFE",
    points: "54.227 227.871 55.155 227.871 55.155 224.247 54.227 224.247"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.4,
    y1: 224.247,
    x2: 52.4,
    y2: 227.871,
    id: "Fill-124",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-125",
    fill: "#FFFFFE",
    points: "51.935 227.871 52.863 227.871 52.863 224.247 51.935 224.247"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-126",
    fill: "#5BBDB7",
    points: "71.15 219.191 72.852 229.708 68.831 230.48 66.82 220.429 71.15 219.191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.542,152.02 L223.774,152.02 C223.774,152.02 224.838,184.557 219.124,185.606 C213.409,186.656 211.077,183.624 211.077,183.624 C211.077,183.624 205.129,193.304 195.216,194.586 C185.304,195.869 171.542,196.103 171.542,196.103 L171.542,152.02",
    id: "Fill-127",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.888,194.285 C200.588,193.721 216.803,190.402 220.431,184.716 C215.64,186.742 211.077,183.624 211.077,183.624 C211.077,183.624 205.129,192.487 196.888,194.285",
    id: "Fill-128",
    fill: "#E98333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.59,144.51 C88.179,145.578 88.424,146.666 89.137,146.939 C89.849,147.214 90.76,146.57 91.17,145.502 C91.581,144.435 91.336,143.347 90.624,143.073 C89.911,142.799 89,143.442 88.59,144.51",
    id: "Fill-129",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.007,207.721 C34.213,222.13 97.801,228.572 97.801,228.572 L99.319,220.429 C99.319,220.429 43.801,193.312 39.007,207.721",
    id: "Fill-130",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-131",
    fill: "#F0AB85",
    points: "101.643 228.544 110.763 229.089 112.489 227.191 111.613 223.754 102.993 222.511 101.643 228.544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.875,222.096 C123.659,221.562 120.042,222.511 120.042,222.511 L110.763,223.631 C111.878,225.149 111.929,227.323 110.891,228.896 L110.763,229.089 L122.052,230.48 C122.052,230.48 124.461,230.793 126.875,230.509 L126.875,222.096",
    id: "Fill-132",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.563,225.8 C130.94,223.42 128.951,222.424 126.798,222.083 L126.798,230.517 C129.592,230.203 132.427,229.103 131.563,225.8",
    id: "Fill-133",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.779,
    y1: 224.247,
    x2: 115.779,
    y2: 227.871,
    id: "Fill-134",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-135",
    fill: "#FFFFFE",
    points: "115.315 227.871 116.243 227.871 116.243 224.247 115.315 224.247"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.07,
    y1: 224.247,
    x2: 118.07,
    y2: 227.871,
    id: "Fill-136",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-137",
    fill: "#FFFFFE",
    points: "117.606 227.871 118.534 227.871 118.534 224.247 117.606 224.247"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-138",
    fill: "#5BBDB7",
    points: "99.319 219.191 97.618 229.708 101.639 230.48 103.649 220.429 99.319 219.191"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-141",
    transform: "translate(1.000000, 114.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-32",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.77,35.825 C49.77,35.825 46.844,31.345 45.813,30.139 C42.07,26.268 49.118,7.513 44.571,4.512 C40.024,1.511 7.186,-2.24 3.6,4.512 C0.013,11.264 -1.806,32.142 4.863,35.058 C11.532,37.974 37.796,35.892 40.706,34.944 C45.594,33.353 49.77,35.825 49.77,35.825",
    id: "Fill-139",
    fill: "url(#linearGradient-33)",
    mask: "url(#mask-32)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.234,121.271 C12.175,123.583 8.918,131.373 9.964,137.685 C10.12,138.624 10.659,139.474 11.48,139.956 C18.402,144.009 27.942,145.366 31.242,145.73 C32.046,145.818 32.84,145.548 33.422,144.987 C35.424,143.056 39.852,137.637 41.289,126.481 C41.382,125.758 41.129,125.021 40.614,124.504 C34.45,118.33 17.206,118.968 14.235,120.275 C13.789,120.472 13.438,120.827 13.234,121.271",
    id: "Fill-142",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-147",
    transform: "translate(9.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-35",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-144"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-143",
    fill: "#FFFFFE",
    mask: "url(#mask-35)",
    points: "16.014 13.626 4.267 1.024 5.053 0.292 16.326 12.385 32.79 6.742 33.139 7.758 16.014 13.626"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-145",
    fill: "#FFFFFE",
    mask: "url(#mask-35)",
    points: "0.085 16.558 -0.384 15.591 12.836 9.198 13.304 10.165 0.085 16.558"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-146",
    fill: "#FFFFFE",
    mask: "url(#mask-35)",
    points: "27.201 23.705 21.087 11.395 22.049 10.918 28.164 23.228 27.201 23.705"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.13,426.461 C205.13,426.461 205.13,436.671 221.917,431.52 C240.141,425.927 236.355,420.953 236.355,420.953 L205.13,426.461",
    id: "Fill-148",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.142,322.932 C90.032,323.708 89.3809989,324.97 89.3809989,326.323 C89.399,347.982 89.864,445.043 103.046,445.176 C129.642,445.443 280.832,414.276 328.933,408.307 C335.454,407.497 334.887,405.883 332.652,399.702 C323.216,373.599 298.631,317.284 281.712,300.201 C278.208,296.663 275.39,296.86 270.419,297.166 C244.55,298.754 186.392,309.63 186.392,309.63 C186.392,309.63 106.967,311.863 91.142,322.932",
    id: "Fill-149",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.708,403.147 C240.574,392.066 260.225,390.395 279.059,389.264 C292.409,388.462 306.264,387.75 319.783,388.895 C302.217,354.335 296.357,339.611 275.887,306.215 C196.64,301.072 187.417,320.144 187.417,320.144 L187.417,320.903 C187.417,320.903 165.214,302.115 94.848,331.555 C100.996,376.879 98.821,435.369 108.511,435.369 C117.843,435.369 210.354,420.704 217.176,419.621 C217.073,413.225 219.584,406.726 224.708,403.147",
    id: "Fill-150",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.887,306.215 C214.188,302.211 193.435,312.498 187.417,320.144 C194.484,344.329 214.88,391.37 219.591,413.595 C222.918,411.871 226.614,411.115 230.237,411.869 C234.755,412.811 239.598,412.854 244.444,412.726 C244.509,412.655 244.571,412.585 244.636,412.516 C251.946,404.748 263.988,402.994 274.111,402.412 C279.424,402.106 284.35,403.074 288.4,405.351 C306.442,402.348 322.211,400.57 326.783,402.501 C320.567,365.545 298.857,343.691 275.887,306.215",
    id: "Fill-151",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.417,320.903 L221.381,410.746 C221.381,410.746 221.552,410.439 221.962,409.85 C225.226,405.153 230.065,401.541 235.687,400.493 C268.211,394.429 325.135,394.462 325.135,394.462 C325.135,394.462 326.783,399.539 327.147,403.303 C308.579,398.192 217.588,419.556 217.588,419.556 C217.588,419.556 116.444,435.369 108.511,435.369 C104.277,435.369 104.277,429.005 104.277,429.005 C104.277,429.005 185.295,403.929 204.302,406.241 C213.608,407.374 217.476,412.05 217.476,412.05",
    id: "Fill-152",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.088,362.187 C441.088,362.187 516.706,313.589 518.985,301.416 C521.264,289.243 469.604,278.624 469.604,278.624 L395.879,325.373 L441.088,362.187",
    id: "Fill-153",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.088,328.731 L441.088,362.187 C441.088,362.187 328.628,316.406 327.72,303.471 C327.109,294.79 327.72,274.182 327.72,274.182 L441.088,328.731",
    id: "Fill-154",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-155",
    fill: "#FFFFFE",
    points: "511.339 274.191 511.339 301.436 445.261 353.811 445.24 325.528 511.339 274.191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.72,274.182 C327.72,282.524 441.088,328.731 441.088,328.731 C441.088,328.731 517.369,278.051 521.071,267.034 C525.765,251.447 443.303,226.118 421.349,219.675 C417.906,218.664 414.232,218.925 410.966,220.408 C394.285,227.976 327.72,265.84 327.72,274.182",
    id: "Fill-156",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.663,300.021 L340.663,300.021 C340.553,296.168 343.31,291.373 346.751,292.98 L402.521,320.665 C405.822,322.207 407.979,325.523 408.085,329.219 L408.114,330.247 C408.267,335.586 408.302,342.327 403.576,340.006 L348.629,311.479 C343.87,309.142 340.817,305.397 340.663,300.021",
    id: "Fill-157",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.745,336.381 C416.745,339.454 419.235,341.945 422.309,341.945 C425.382,341.945 427.873,339.454 427.873,336.381 C427.873,333.309 425.382,330.817 422.309,330.817 C419.235,330.817 416.745,333.309 416.745,336.381",
    id: "Fill-158",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.44,336.381 C417.44,339.07 419.62,341.25 422.309,341.25 C424.998,341.25 427.178,339.07 427.178,336.381 C427.178,333.692 424.998,331.513 422.309,331.513 C419.62,331.513 417.44,333.692 417.44,336.381",
    id: "Fill-159",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.334,285.467 C501.47,292.595 492.004,299.993 482.566,307.369 L511.334,285.473 L511.334,285.467",
    id: "Fill-160",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.566,307.369 L454.333,328.859 C463.958,321.91 473.249,314.651 482.566,307.369",
    id: "Fill-161",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-162",
    fill: "#5BBDB7",
    points: "511.334 285.032 511.33 285.028 445.261 335.316 445.261 336.212 511.334 285.921 511.334 285.032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.334,285.921 C492.269,300.43 472.942,314.928 454.26,329.362 L511.334,285.921",
    id: "Fill-163",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.334,281.63 C497.055,291.703 483.608,302.523 469.873,313.196 L511.334,281.639 L511.334,281.63",
    id: "Fill-164",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.873,313.196 L454.333,325.025 C459.594,321.135 464.753,317.176 469.873,313.196",
    id: "Fill-165",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-166",
    fill: "#5BBDB7",
    points: "511.334 281.199 511.33 281.194 445.261 331.482 445.261 332.378 511.334 282.087 511.334 281.199"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.334,291.312 C492.264,305.822 473.283,320.07 454.343,334.693 L511.334,291.314 L511.334,291.312",
    id: "Fill-167",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-168",
    fill: "#5BBDB7",
    points: "511.334 290.867 445.261 341.158 445.261 341.756 445.403 341.945 511.334 291.763 511.334 290.867"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.334,291.763 L454.283,335.187 C473.216,320.811 492.133,306.614 511.334,291.78 L511.334,291.763",
    id: "Fill-169",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.334,297.083 C497.137,307.371 483.271,318.321 469.231,329.147 L511.334,297.102 L511.334,297.083",
    id: "Fill-170",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.231,329.147 L454.332,340.488 C459.336,336.747 464.294,332.955 469.231,329.147",
    id: "Fill-171",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-172",
    fill: "#5BBDB7",
    points: "511.334 296.653 445.261 346.945 445.261 347.841 511.334 297.55 511.334 296.653"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.334,297.55 L482.981,319.13 C492.519,312.047 502.065,304.948 511.334,297.571 L511.334,297.55",
    id: "Fill-173",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.981,319.13 C473.287,326.33 463.608,333.52 454.264,340.988 L482.981,319.13",
    id: "Fill-174",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.958,124.631 C382.958,124.631 465.157,90.443 470.364,93.786 C475.572,97.13 470.364,136.905 470.364,136.905 L383.844,144.234 L382.958,124.631",
    id: "Fill-175",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-176",
    fill: "#13374D",
    points: "382.958 279.183 382.958 124.631 408.943 128.587 408.943 286.27 382.958 279.183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.943,128.587 C408.943,128.587 489.545,93.38 498.713,100.424 C506.566,106.458 508.169,205.451 498.713,250.244 C482.092,252.735 408.943,286.27 408.943,286.27 L408.943,128.587",
    id: "Fill-177",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.978,167.72 C387.978,171.634 391.15,174.807 395.064,174.807 C398.979,174.807 402.152,171.634 402.152,167.72 C402.152,163.806 398.979,160.633 395.064,160.633 C391.15,160.633 387.978,163.806 387.978,167.72",
    id: "Fill-178",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.863,167.72 C388.863,171.145 391.64,173.921 395.064,173.921 C398.489,173.921 401.266,171.145 401.266,167.72 C401.266,164.295 398.489,161.519 395.064,161.519 C391.64,161.519 388.863,164.295 388.863,167.72",
    id: "Fill-179",
    fill: "#A0D2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.978,218.073 C387.978,221.987 391.15,225.16 395.064,225.16 C398.979,225.16 402.152,221.987 402.152,218.073 C402.152,214.159 398.979,210.986 395.064,210.986 C391.15,210.986 387.978,214.159 387.978,218.073",
    id: "Fill-180",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.863,218.073 C388.863,221.498 391.64,224.274 395.064,224.274 C398.489,224.274 401.266,221.498 401.266,218.073 C401.266,214.648 398.489,211.872 395.064,211.872 C391.64,211.872 388.863,214.648 388.863,218.073",
    id: "Fill-181",
    fill: "#A0D2BB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-184",
    transform: "translate(427.000000, 130.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-37",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92,13.889 C4.775,16.645 2.686,21.631 1.885,27.342 C0.015,40.671 -0.85,64.883 6.064,71.537 C13.145,78.35 31.971,67.514 43.122,61.178 C47.517,58.682 50.558,54.412 51.491,49.503 C54.347,34.478 59.172,2.319 48.508,0.764 C38.927,-0.633 20.504,8.217 9.92,13.889",
    id: "Fill-182",
    mask: "url(#mask-37)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M476.643,170.586 C476.234,170.559 475.825,170.555 475.416,170.537 C475.008,170.599 474.35,170.68 473.37,170.787 C461.612,173.847 449.876,176.888 438.178,180.229 C434.664,181.233 431.194,182.123 427.735,182.9 C428.215,191.064 429.737,198.335 433.064,201.537 C440.145,208.35 458.971,197.514 470.122,191.178 C474.517,188.682 477.558,184.412 478.491,179.503 C478.971,176.979 479.505,173.966 480.014,170.701 C478.891,170.673 477.769,170.633 476.643,170.586",
    id: "Fill-185",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.754,196.92 C453.017,195.49 463.309,188.576 465.569,179.77 C466.748,175.181 464.458,169.654 461.394,169.496 C451.967,169.008 449.026,195.41 449.026,195.41 L450.167,197.028 C450.362,196.989 450.559,196.955 450.754,196.92",
    id: "Fill-186",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.884,197.08 C451.87,191.426 458.619,173.567 464.893,172.544 L464.605,171.984 C457.86,173.065 451.041,192.104 449.325,197.206 C449.512,197.164 449.696,197.118 449.884,197.08",
    id: "Fill-187",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.021,179.21 C443.573,188.706 445.34,194.866 446.026,198.101 C447.558,197.604 449.126,197.213 450.715,196.927 C452.528,188.502 456.111,168.278 450.921,159.674 C447.856,154.594 444.665,153.492 442.048,153.815 C437.235,154.41 434.042,161.642 435.585,169.296 C436.157,172.138 437.218,175.452 439.021,179.21",
    id: "Fill-188",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.853,200.258 C442.599,199.354 444.434,198.604 446.324,198.008 C445.848,191.988 443.696,178.397 433.966,177.166 C431.354,176.835 429.239,180.492 429.859,184.513 C431.373,194.317 437.735,198.68 440.853,200.258",
    id: "Fill-189",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.858,197.563 C448.012,197.522 448.165,197.479 448.319,197.439 C448.873,188.919 449.364,166.559 440.647,154.19 L440.189,154.407 C448.86,166.697 448.374,189.274 447.858,197.563",
    id: "Fill-190",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.897,198.872 C444.061,198.807 444.221,198.738 444.385,198.676 C442.282,193.61 436.454,180.889 430.444,179.717 L430.174,180.41 C435.845,181.502 441.686,193.751 443.897,198.872",
    id: "Fill-191",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.761,144.672 C461.761,147.688 464.205,150.132 467.22,150.132 C470.235,150.132 472.679,147.688 472.679,144.672 C472.679,141.657 470.235,139.213 467.22,139.213 C464.205,139.213 461.761,141.657 461.761,144.672",
    id: "Fill-192",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-193",
    fill: "#FFFFFE",
    points: "260.167 102.167 260.167 157.341 327.052 152.813 323.796 90.276 260.167 102.167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.196,298.765 L436.955,296.198 C439.216,296.093 441.799,296.348 442.509,298.214 C442.509,298.214 442.995,299.449 443.14,300.73 C442.652,301.518 420.307,304.105 420.307,304.105 L420.197,304.04 C417.412,301.564 420.196,298.765 420.196,298.765",
    id: "Fill-194",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-195",
    fill: "#FFFFFE",
    points: "443.14 300.73 420.307 304.105 420.639 304.963 443.293 301.521 443.14 300.73"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-196",
    fill: "#FFFFFE",
    points: "426.828 297.736 428.339 297.518 428.181 299.644 426.717 299.865 426.828 297.736"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-197",
    fill: "#FFFFFE",
    points: "430.064 297.245 431.575 297.025 431.417 299.151 429.953 299.374 430.064 297.245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.197,293.355 L420.196,298.765 C421.646,299.24 423.399,299.017 424.706,298.188 L424.943,298.037 L424.903,292.337 L418.197,293.355",
    id: "Fill-198",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.392,289.992 L476.542,273.333 C477.194,271.167 478.294,268.814 480.29,268.766 C480.29,268.766 481.616,268.718 482.873,269.008 C483.453,269.729 478.465,291.664 478.465,291.664 L478.367,291.745 C475.106,293.549 473.392,289.992 473.392,289.992",
    id: "Fill-199",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-200",
    fill: "#FFFFFE",
    points: "482.873 269.008 478.465 291.664 479.385 291.636 483.669 269.126 482.873 269.008"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-201",
    fill: "#FFFFFE",
    points: "474.627 283.396 474.922 281.898 476.875 282.754 476.598 284.208 474.627 283.396"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-202",
    fill: "#FFFFFE",
    points: "475.239 280.18 475.534 278.683 477.487 279.538 477.21 280.992 475.239 280.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.626,290.079 L473.392,289.992 C474.322,288.784 474.693,287.056 474.347,285.548 L474.284,285.273 L468.895,283.416 L467.626,290.079",
    id: "Fill-203",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.418,281.774 C370.418,281.774 388.652,287.976 415.38,286.29 C419.789,286.012 424.214,286.634 428.385,288.091 C444.57,293.747 468.571,290.725 468.571,290.725 L470.289,283.204 L390.27,262.311 L370.418,281.774",
    id: "Fill-204",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-205",
    fill: "#EC967C",
    points: "360.802 199.351 357.528 207.125 364.172 209.106 366.733 202.806 360.802 199.351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.686,185.669 L359.697,196.181 C360.741,196.39 361.078,197.646 360.646,198.569 C360.696,198.832 360.692,199.108 360.634,199.376 C362.115,201.095 364.968,203.559 369.363,203.773 C376.24,204.108 375.354,190.444 375.354,190.444 L361.686,185.669",
    id: "Fill-206",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-209",
    transform: "translate(354.000000, 178.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-39",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.491,14.667 C2.627,13.894 1.98,12.027 1.523,11.388 C-1.417,7.267 2.48,5.727 3.845,5.254 C5.354,4.732 5.671,2.301 7.683,1.388 C10.754,-0.006 12.734,2.69 14.462,2.785 C16.188,2.879 17.748,0.93 19.869,2.677 C21.991,4.425 21.269,6.248 21.846,7.23 C22.424,8.213 24.372,6.356 26.107,9.438 C28.747,14.126 21.356,14.067 21.356,14.067 C21.356,14.067 17.145,14.724 12.559,11.507 C11.931,11.066 11.068,11.017 10.481,11.513 C8.871,12.873 6.757,21.533 6.757,21.533 L5.407,19.717 C5.407,19.717 1.87,18.21 2.491,14.667",
    id: "Fill-207",
    fill: "#1B2441",
    mask: "url(#mask-39)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M360.228,194.473 C360.363,195.369 361.2,195.985 362.096,195.849 C362.991,195.713 363.607,194.876 363.472,193.98 C363.335,193.084 362.499,192.469 361.603,192.604 C360.707,192.741 360.091,193.578 360.228,194.473",
    id: "Fill-210",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.766,258.768 C343.766,258.768 345.666,280.225 365.102,281.84 C384.537,283.454 408.322,262.115 408.322,262.115 L417.822,294.575 L425.356,293.431 C425.356,293.431 428.826,245.492 418.477,242.515 C408.127,239.538 368.633,254.989 368.633,254.989 L343.766,258.768",
    id: "Fill-211",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.766,258.768 L375.718,253.913 C375.718,253.913 373.558,246.93 373.156,239.635 C372.853,234.113 374.927,229.177 374.927,229.177 C373.182,216.969 368.736,205.082 357.939,206.366 C339.497,210.881 343.766,258.768 343.766,258.768",
    id: "Fill-212",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-213",
    fill: "#FFFFFE",
    points: "433.104 213.435 421.993 241.691 393.805 238.348 393.539 240.593 423.458 244.141 435.206 214.262 433.104 213.435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.267,230.832 L374.887,228.915 L376.223,243.034 L398.46,236.039 L403.396,232.76 C404.67,231.912 406.212,231.565 407.727,231.785 L413.849,232.672 C414.479,232.764 414.977,233.257 415.072,233.888 L417.301,240.409 C417.301,240.409 415.847,241.487 413.489,235.995 C412.383,242.489 403.162,238.18 403.162,238.18 L400.068,240.363 C400.068,240.363 376.257,257.971 370.265,254.741 C364.272,251.512 362.267,230.832 362.267,230.832",
    id: "Fill-214",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.072,233.888 C414.977,233.257 414.479,232.764 413.849,232.672 L407.727,231.785 C406.212,231.565 404.67,231.912 403.396,232.76 L398.46,236.039 L397.733,236.268 L398.524,241.477 C399.501,240.782 400.068,240.363 400.068,240.363 L403.162,238.18 C403.162,238.18 412.383,242.489 413.489,235.994 C415.847,241.487 417.301,240.409 417.301,240.409 L415.072,233.888",
    id: "Fill-215",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.553,85.958 L353.479,91.6 C353.479,91.6 351.021,124.062 345.228,124.488 C339.433,124.914 337.441,121.648 337.441,121.648 C337.441,121.648 330.482,130.628 320.489,130.833 C310.496,131.038 296.79,129.783 296.79,129.783 L301.553,85.958",
    id: "Fill-216",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.184,130.713 C325.924,130.552 342.402,129.005 346.623,123.745 C341.641,125.241 337.441,121.648 337.441,121.648 C337.441,121.648 330.571,129.817 322.184,130.713",
    id: "Fill-217",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-218",
    fill: "#F0AB85",
    points: "231.485 319.542 235.432 329.287 228.92 345.789 222.013 323.193 231.485 319.542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.247,295.688 L124.523,308.491 L118.998,341.645 C118.998,341.645 123.142,341.645 124.523,341.645 C138.732,326.055 138.732,297.439 138.732,297.439 L130.247,295.688",
    id: "Fill-219",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.215,352.499 L116.206,352.499 C112.348,352.499 109.367,349.111 109.856,345.285 L116.432,293.887 L125.116,293.887 C125.116,293.887 126.892,308.392 127.089,316.532 C127.878,325.463 122.748,338.882 122.748,338.882 C122.748,338.882 152.547,320.727 165.375,321.91 C175.439,323.193 177.88,321.318 177.88,321.318 L177.215,352.499",
    id: "Fill-220",
    fill: "#A0D2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.684,306.912 C216.684,306.912 225.368,305.728 231.485,319.542 C228.92,322.699 225.269,324.673 225.269,324.673 C225.269,324.673 225.903,334.675 222.407,336.909 C218.912,339.143 197.344,352.499 197.344,352.499 L177.215,352.499 L177.215,325.66 L205.436,306.075 L216.684,306.912",
    id: "Fill-221",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.197,298.887 C207.902,298.887 209.679,307.208 209.679,307.208 C209.679,307.208 209.777,319.542 214.119,319.542 C219.053,319.542 219.053,306.847 219.053,306.847 L219.053,303.458 C219.053,303.458 210.491,298.887 209.197,298.887",
    id: "Fill-222",
    fill: "#EC967C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.103,305.961 C219.306,306.14 220.451,306.143 221.125,305.728 C225.565,300.844 225.565,285.303 225.565,285.303 L211.356,285.303 L209.174,295.173 C208.592,297.808 209.298,300.562 211.076,302.592 C213.053,304.356 215.481,305.572 218.103,305.961",
    id: "Fill-223",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-226",
    transform: "translate(160.000000, 278.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-41",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.91,26.691 C25.269,20.554 32.502,23.655 36.259,21.955 C42.476,19.144 45.88,-0.098 56.906,0.938 C67.933,1.974 67.933,9.375 67.933,9.375 C67.933,9.375 70.385,15.697 55.168,14.247 C52.729,14.014 49.649,15.295 49.591,17.744 C49.446,23.884 49.679,29.208 49.679,29.208 C49.679,29.208 38.331,32.76 34.039,36.757 C29.747,40.753 21.902,61.179 9.321,61.178 C-2.52,60.142 -4.444,36.608 13.91,26.691",
    id: "Fill-224",
    fill: "#1B2441",
    mask: "url(#mask-41)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187.674,327.633 L199.121,334.343 L194.02,343.818 C192.772,345.464 193.914,346.645 195.978,346.691 L224.381,347.368 L224.381,352.499 C224.381,352.499 185.411,352.499 180.228,352.499 C175.044,352.499 187.674,327.633 187.674,327.633",
    id: "Fill-227",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-228",
    fill: "#1B2441",
    points: "269.968 325.66 230.301 325.66 217.27 352.499 256.943 352.499 269.968 325.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-229",
    fill: "#1B2441",
    points: "206.028 352.499 256.943 352.499 256.943 350.131 206.028 350.131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.324,335.441 C245.324,336.319 246.037,337.032 246.915,337.032 C247.794,337.032 248.506,336.319 248.506,335.441 C248.506,334.563 247.794,333.85 246.915,333.85 C246.037,333.85 245.324,334.563 245.324,335.441",
    id: "Fill-230",
    fill: "#E7E7E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.518,293.887 L118.998,286.042 L120.181,285.798 C120.939,285.642 121.72,285.631 122.482,285.767 L124.03,286.042 L124.03,293.887 L117.518,293.887",
    id: "Fill-231",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.998,286.042 L112.282,277.147 C111.207,275.723 110.284,273.851 111.497,272.169 C111.497,272.169 112.293,271.045 113.276,270.117 C114.132,269.928 126.028,283.008 126.028,283.008 L126.022,283.123 C125.943,284.758 124.918,286.228 122.661,286.228 L118.998,286.042",
    id: "Fill-232",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-233",
    fill: "#FFFFFE",
    points: "113.276 270.117 126.028 283.008 126.583 282.231 113.854 269.502 113.276 270.117"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-234",
    fill: "#FFFFFE",
    points: "117.468 284.044 116.782 283.079 118.655 281.748 119.341 282.714 117.468 284.044"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-235",
    fill: "#FFFFFE",
    points: "115.695 281.701 115.014 280.732 116.992 279.342 117.673 280.311 115.695 281.701"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.441,289.629 L131.877,279.068 C131.307,277.377 131.022,275.309 132.704,274.097 C132.704,274.097 133.814,273.281 135.04,272.711 C135.912,272.802 143.07,288.97 143.07,288.97 L143.028,289.076 C142.437,290.603 141,291.674 138.858,290.961 L135.441,289.629",
    id: "Fill-236",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-237",
    fill: "#FFFFFE",
    points: "135.04 272.711 143.07 288.97 143.842 288.407 135.783 272.311 135.04 272.711"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-238",
    fill: "#FFFFFE",
    points: "134.62 287.25 134.274 286.117 136.471 285.446 136.817 286.578 134.62 287.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-239",
    fill: "#FFFFFE",
    points: "133.678 284.467 133.337 283.333 135.653 282.637 135.994 283.771 133.678 284.467"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-240",
    fill: "#F0AB85",
    points: "131.862 296.022 135.427 289.545 140.23 291.187 138.003 297.289 131.862 296.022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.994,277.424 L255.371,286.361 C255.652,287.611 255.7,289.107 254.41,289.847 C254.41,289.847 253.557,290.345 252.64,290.66 C252.024,290.53 248.127,278.461 248.127,278.461 L248.164,278.388 C249.709,276.373 251.994,277.424 251.994,277.424",
    id: "Fill-241",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-242",
    fill: "#1B2441",
    points: "252.64 290.66 248.127 278.461 247.534 278.805 252.08 290.891 252.64 290.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-243",
    fill: "#FFFFFE",
    points: "253.339 280.959 253.635 281.767 252.077 282.066 251.784 281.285 253.339 280.959"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-244",
    fill: "#FFFFFE",
    points: "253.989 282.686 254.284 283.493 252.727 283.793 252.433 283.012 253.989 282.686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.739,275.314 L251.994,277.424 C251.779,278.324 252.1,279.268 252.82,279.85 L252.951,279.956 L257.085,278.893 L255.739,275.314",
    id: "Fill-245",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.646,218.922 C285.646,218.922 281.931,222.923 280.974,229.964 C280.337,234.649 282.091,242.076 282.282,247.901 C282.458,253.229 280.054,257.463 275.831,260.717 L255.739,275.314 L257.085,278.893 C257.085,278.893 284.584,274.769 291.804,262.452 C299.022,250.137 300.734,222.255 300.734,222.255 L285.646,218.922",
    id: "Fill-246",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.648,203.747 L259.314,226.821 C259.314,226.821 255.068,227.316 253.228,228.944 C252.266,229.795 252.31,231.497 252.57,232.928 C252.768,234.012 254.072,234.472 254.904,233.749 C256.04,232.763 257.504,231.652 258.466,231.492 C261.014,231.068 261.777,229.263 261.777,229.263 L276.603,206.012 L269.648,203.747",
    id: "Fill-247",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.758,157.341 L327.052,152.813 L322.946,130.447 L316.576,127.191 C316.576,127.191 317.271,125.959 318.842,126.483 C320.413,127.007 321.743,126.695 321.743,126.695 C321.743,126.695 322.937,125.22 320.677,124.223 C319.407,123.369 318.559,124.218 314.878,124.076 C314.878,123.51 319.728,122.166 319.728,122.166 C321.24,121.679 325.101,124.669 325.101,124.669 C325.359,125.023 325.528,125.436 325.592,125.871 L326.203,130.022 C326.203,130.022 334.413,152.533 334.413,154.937 C334.413,157.341 329.813,160.633 329.813,160.633 L321.758,157.341",
    id: "Fill-248",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.29,221.244 C293.29,221.244 290.104,225.08 292.016,233.999 C293.235,239.691 298.593,246.855 302.19,251.79 C304.771,255.327 304.825,259.776 304.05,264.086 C301.104,280.465 305.817,300.462 305.817,300.462 L309.64,300.462 C309.64,300.462 315.373,271.158 317.072,250.562 C318.604,231.989 310.656,218.313 310.489,218.073 L293.29,221.244",
    id: "Fill-249",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-250",
    fill: "#EE9E35",
    points: "314.476 126.386 326.479 128.147 326.944 124.976 314.94 123.214 314.476 126.386"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-251",
    fill: "#FFFFFE",
    points: "327.638 125.077 327.172 128.249 326.075 128.088 326.541 124.916 327.638 125.077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.941,128.214 C327.82,128.338 328.562,128.278 328.771,126.844 C329.001,125.277 328.289,125.139 327.412,125.005 L326.941,128.214",
    id: "Fill-252",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-253",
    fill: "#FFFFFE",
    points: "314.476 126.386 312.146 124.985 312.315 123.832 314.94 123.214 314.476 126.386"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-254",
    fill: "#13374D",
    points: "312.146 124.985 311.133 124.255 312.315 123.832 312.146 124.985"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-255",
    fill: "#E98333",
    points: "326.253 126.878 326.147 127.6 314.547 125.898 314.653 125.176 326.253 126.878"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-256",
    fill: "#E98333",
    points: "326.478 125.349 326.371 126.07 314.771 124.369 314.877 123.647 326.478 125.349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.909,175.968 C277.081,180.984 269.042,205.102 269.042,205.102 L275.038,208.465 L284.796,195.075 C284.796,195.075 285.748,210.577 283.412,222.468 C284.474,226.928 289.539,226.426 297.749,224.868 C305.96,223.312 311.339,219.772 311.339,219.772 C311.339,219.772 311.693,198.264 312.755,186.859 C313.816,175.454 311.72,174.236 314.595,174.614 C321.009,170.971 331.52,159.239 331.52,159.239 L321.758,157.341 L300.734,169.658 C300.734,169.658 290.455,172.367 283.909,175.968",
    id: "Fill-257",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.82,147.44 L300.893,152.45 C303.046,154.576 303.955,157.661 303.298,160.615 L302.703,163.289 L295.82,147.44",
    id: "Fill-258",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-261",
    transform: "translate(281.000000, 145.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-43",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-260"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68,0.545 C-3.636,0.545 1.602,24.188 1.602,24.188 C1.602,24.188 3.796,39.523 8.68,45.681 C12.907,51.011 21.271,49.408 25.232,46.849 C27.169,45.599 29.339,44.765 31.627,44.489 C34.982,44.085 38.974,42.604 38.974,36.55 C38.974,30.853 32.172,26.446 27.695,23.298 C24.777,21.247 22.742,18.18 21.892,14.716 C20.459,8.882 16.963,0.545 8.68,0.545",
    id: "Fill-259",
    fill: "#1B2441",
    mask: "url(#mask-43)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M306.474,304.71 L316.027,304.695 C317.296,304.872 318.714,305.354 318.951,306.822 C318.951,306.822 319.117,307.796 319.09,308.766 C318.751,309.295 306.083,308.694 306.083,308.694 L306.027,308.634 C304.686,306.479 306.474,304.71 306.474,304.71",
    id: "Fill-262",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-263",
    fill: "#13374D",
    points: "319.09 308.766 306.083 308.694 306.195 309.37 319.108 309.37 319.09 308.766"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-264",
    fill: "#FFFFFE",
    points: "310.255 304.695 311.115 304.703 310.848 306.267 310.014 306.267 310.255 304.695"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-265",
    fill: "#FFFFFE",
    points: "312.1 304.695 312.96 304.703 312.692 306.267 311.858 306.267 312.1 304.695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.817,300.462 L306.474,304.71 C307.24,305.229 308.236,305.26 309.035,304.791 L309.18,304.706 L309.64,300.462 L305.817,300.462",
    id: "Fill-266",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.842,126.483 C317.271,125.959 316.576,127.191 316.576,127.191 L320.814,129.357 C320.874,129.332 320.931,129.303 320.99,129.279 C321.686,128.996 323.132,128.371 323.796,128.257 C323.394,127.854 319.626,126.745 318.842,126.483",
    id: "Fill-267",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.989,363.603 C285.855,363.582 282.682,363.083 280.912,360.546 C279.823,358.985 279.516,357.02 279.997,354.7 C280.583,351.878 281.692,350.003 283.294,349.128 C285.019,348.186 286.647,348.79 286.716,348.816 L286.318,349.863 C286.268,349.845 285.078,349.417 283.813,350.119 C282.522,350.835 281.607,352.453 281.094,354.928 C280.677,356.934 280.925,358.608 281.83,359.906 C283.326,362.052 286.127,362.491 286.154,362.495 L285.989,363.603",
    id: "Fill-268",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.251,376.681 C294.117,376.661 290.943,376.161 289.174,373.625 C288.085,372.064 287.777,370.098 288.259,367.779 C288.845,364.956 289.954,363.082 291.556,362.206 C293.28,361.264 294.909,361.868 294.978,361.896 L294.58,362.941 C294.529,362.923 293.34,362.496 292.075,363.197 C290.784,363.914 289.869,365.531 289.355,368.007 C288.938,370.012 289.187,371.687 290.092,372.984 C291.588,375.13 294.389,375.57 294.416,375.573 L294.251,376.681",
    id: "Fill-269",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.633,389.329 C303.498,389.31 300.324,388.81 298.555,386.273 C297.467,384.713 297.159,382.746 297.64,380.428 C298.227,377.604 299.335,375.73 300.937,374.854 C302.661,373.912 304.29,374.517 304.358,374.543 L303.962,375.59 C303.911,375.571 302.722,375.145 301.457,375.846 C300.166,376.562 299.25,378.18 298.736,380.654 C298.319,382.66 298.567,384.335 299.473,385.633 C300.969,387.778 303.77,388.218 303.798,388.222 L303.633,389.329",
    id: "Fill-270",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.014,401.134 C312.879,401.114 309.705,400.614 307.936,398.078 C306.848,396.518 306.54,394.551 307.021,392.232 C307.607,389.409 308.717,387.535 310.318,386.659 C312.042,385.717 313.671,386.321 313.739,386.349 L313.343,387.395 C313.292,387.376 312.103,386.949 310.838,387.65 C309.547,388.367 308.631,389.984 308.117,392.46 C307.701,394.465 307.948,396.14 308.854,397.438 C310.351,399.583 313.151,400.023 313.179,400.027 L313.014,401.134",
    id: "Fill-271",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.701,413.213 C322.566,413.193 318.272,412.693 316.504,410.157 C315.415,408.597 315.107,406.63 315.589,404.312 C316.175,401.488 317.284,399.614 318.886,398.738 C320.61,397.796 322.239,398.4 322.308,398.428 L321.91,399.474 C321.859,399.455 320.67,399.028 319.405,399.729 C318.114,400.446 317.199,402.063 316.686,404.539 C316.269,406.544 316.517,408.219 317.422,409.517 C318.918,411.662 321.719,412.103 321.746,412.106 L322.701,413.213",
    id: "Fill-272",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.029,424.34 C331.895,424.319 328.721,423.82 326.951,421.283 C325.863,419.723 325.556,417.756 326.036,415.438 C326.623,412.615 327.731,410.74 329.333,409.865 C331.058,408.923 332.687,409.527 332.755,409.554 L332.358,410.6 C332.307,410.582 331.118,410.154 329.853,410.856 C328.562,411.572 327.646,413.19 327.133,415.665 C326.716,417.671 326.964,419.345 327.869,420.644 C329.365,422.789 332.166,423.229 332.194,423.232 L332.029,424.34",
    id: "Fill-273",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.499,436.085 C322.637,420.097 286.465,365.628 277.73,352.209 C276.463,350.262 275.778,347.994 275.757,345.671 L275.657,334.811 L344.499,423.771 L344.499,436.085",
    id: "Fill-274",
    fill: "#A0D2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.499,423.212 L344.499,436.085 L427.055,402.83 C428.922,402.078 430.154,400.278 430.181,398.266 L430.269,391.523 L344.499,423.212",
    id: "Fill-275",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-278",
    transform: "translate(274.000000, 303.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-45",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-277"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.767,36.764 C11.749,52.869 38.848,94.598 66.691,120.18 C69.036,122.334 72.353,123.06 75.389,122.098 C102.768,113.42 152.91,91.322 152.91,91.322 C156.697679,89.841 157.918,85.083 155.313,81.961 L89.729,3.353 C87.923,1.188 84.969,0.359 82.3,1.271 L5.026,27.645 C1.261,28.93 -0.33,33.382 1.767,36.764",
    id: "Fill-276",
    fill: "url(#linearGradient-46)",
    mask: "url(#mask-45)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M311.546,347.716 C309.52,343.241 311.431,337.974 315.856,335.843 C326.033,330.943 343.523,323.103 351.218,323.103 C357.958,323.103 368.759,336.676 376.285,347.474 C380.983,354.214 381.676,361.316 374.12,364.543 C362.021,369.709 345.977,377.877 338.902,377.877 C330.593,377.877 316.686,359.065 311.546,347.716",
    id: "Fill-279",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-280",
    fill: "#FFFFFE",
    points: "328.952 350.924 328.339 349.734 359.153 337.745 359.768 338.934 328.952 350.924"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-281",
    fill: "#FFFFFE",
    points: "331.901 358.511 331.288 357.321 362.104 345.332 362.717 346.521 331.901 358.511"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-282",
    fill: "#A0D2BB",
    points: "345.377 430.003 345.175 429.48 430.112 396.649 430.314 397.172 345.377 430.003"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-283",
    fill: "#A0D2BB",
    points: "345.017 432.703 344.814 432.181 429.751 399.35 429.953 399.872 345.017 432.703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.828,409.897 C330.828,411.104 331.806,412.083 333.013,412.083 C334.219,412.083 335.197,411.104 335.197,409.897 C335.197,408.691 334.219,407.713 333.013,407.713 C331.806,407.713 330.828,408.691 330.828,409.897",
    id: "Fill-284",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.194,422.607 C328.744,422.498 329.31,422.436 329.886,422.436 C329.91,422.436 329.934,422.439 329.957,422.44 C329.224,422.047 328.449,421.475 327.869,420.644 C326.964,419.345 326.716,417.671 327.133,415.665 C327.646,413.19 328.562,411.572 329.853,410.856 C331.118,410.154 332.307,410.582 332.358,410.6 L332.755,409.554 C332.687,409.527 331.058,408.923 329.333,409.865 C327.731,410.74 326.623,412.615 326.036,415.438 C325.556,417.756 325.863,419.723 326.951,421.283 C327.318,421.81 327.746,422.243 328.194,422.607",
    id: "Fill-285",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.38,398.771 C320.38,399.979 321.358,400.956 322.564,400.956 C323.771,400.956 324.75,399.979 324.75,398.771 C324.75,397.564 323.771,396.587 322.564,396.587 C321.358,396.587 320.38,397.564 320.38,398.771",
    id: "Fill-286",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.886,398.738 C317.284,399.614 316.175,401.488 315.589,404.312 C315.243,405.978 315.315,407.457 315.783,408.739 C316.306,408.85 316.807,409.027 317.274,409.275 C316.497,408.013 316.294,406.424 316.686,404.539 C317.199,402.063 318.114,400.446 319.405,399.729 C320.67,399.028 321.859,399.455 321.91,399.474 L322.308,398.428 C322.239,398.4 320.61,397.796 318.886,398.738",
    id: "Fill-287",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.813,386.692 C311.813,387.899 312.791,388.877 313.997,388.877 C315.204,388.877 316.182,387.899 316.182,386.692 C316.182,385.485 315.204,384.508 313.997,384.508 C312.791,384.508 311.813,385.485 311.813,386.692",
    id: "Fill-288",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.42,398.924 C309.854,398.556 309.297,398.073 308.854,397.438 C307.948,396.14 307.701,394.465 308.117,392.46 C308.631,389.984 309.547,388.367 310.838,387.65 C312.103,386.949 313.292,387.376 313.343,387.395 L313.739,386.349 C313.671,386.321 312.042,385.717 310.318,386.659 C308.717,387.535 307.607,389.409 307.021,392.232 C306.54,394.551 306.848,396.518 307.936,398.078 C308.303,398.604 308.73,399.037 309.179,399.402 C309.549,399.328 309.928,399.286 310.31,399.26 C310.343,399.145 310.382,399.035 310.42,398.924",
    id: "Fill-289",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.432,374.888 C302.432,376.094 303.409,377.072 304.616,377.072 C305.822,377.072 306.801,376.094 306.801,374.888 C306.801,373.681 305.822,372.703 304.616,372.703 C303.409,372.703 302.432,373.681 302.432,374.888",
    id: "Fill-290",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.798,387.598 C300.348,387.488 300.914,387.425 301.489,387.425 C301.514,387.425 301.537,387.43 301.561,387.43 C300.827,387.037 300.053,386.464 299.473,385.633 C298.567,384.335 298.319,382.66 298.736,380.654 C299.25,378.18 300.166,376.562 301.457,375.846 C302.722,375.145 303.911,375.571 303.962,375.59 L304.358,374.543 C304.29,374.517 302.661,373.912 300.937,374.854 C299.335,375.73 298.227,377.604 297.64,380.428 C297.159,382.746 297.467,384.713 298.555,386.273 C298.922,386.799 299.35,387.232 299.798,387.598",
    id: "Fill-291",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.05,362.239 C293.05,363.445 294.028,364.424 295.235,364.424 C296.441,364.424 297.42,363.445 297.42,362.239 C297.42,361.032 296.441,360.055 295.235,360.055 C294.028,360.055 293.05,361.032 293.05,362.239",
    id: "Fill-292",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.416,374.949 C290.967,374.84 291.532,374.776 292.107,374.776 C292.132,374.776 292.155,374.781 292.18,374.781 C291.446,374.389 290.671,373.815 290.092,372.984 C289.187,371.687 288.938,370.012 289.355,368.007 C289.869,365.531 290.784,363.914 292.075,363.197 C293.34,362.496 294.529,362.923 294.58,362.941 L294.978,361.896 C294.909,361.868 293.28,361.264 291.556,362.206 C289.954,363.082 288.845,364.956 288.259,367.779 C287.777,370.098 288.085,372.064 289.174,373.625 C289.54,374.15 289.969,374.584 290.416,374.949",
    id: "Fill-293",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.788,349.161 C284.788,350.367 285.767,351.346 286.974,351.346 C288.18,351.346 289.158,350.367 289.158,349.161 C289.158,347.954 288.18,346.977 286.974,346.977 C285.767,346.977 284.788,347.954 284.788,349.161",
    id: "Fill-294",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.154,361.87 C282.705,361.761 283.271,361.698 283.847,361.698 C283.87,361.698 283.894,361.703 283.918,361.703 C283.185,361.31 282.41,360.737 281.83,359.906 C280.925,358.608 280.677,356.934 281.094,354.928 C281.607,352.453 282.522,350.835 283.813,350.119 C285.078,349.417 286.268,349.845 286.318,349.863 L286.716,348.816 C286.647,348.79 285.019,348.186 283.294,349.128 C281.692,350.003 280.583,351.878 279.997,354.7 C279.516,357.02 279.823,358.985 280.912,360.546 C281.278,361.072 281.707,361.506 282.154,361.87",
    id: "Fill-295",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.157,218.491 C393.441,216.934 376.828,180.21 394.464,166.921 L395.667,168.519 C379.305,180.849 395.806,217.289 395.974,217.655 L394.157,218.491",
    id: "Fill-296",
    fill: "#00A09F"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-297",
    fill: "#A0D2BB",
    points: "482.875 39.019 479.156 45.585 486.405 44.271 511.302 37.641 482.875 39.019"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-298",
    fill: "#5BBDB7",
    points: "479.156 45.585 491.381 45.376 488.462 43.723 479.156 45.585"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-301",
    transform: "translate(481.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-48",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-300"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-299",
    fill: "url(#linearGradient-49)",
    mask: "url(#mask-48)",
    points: "1.875 7.019 0.037 0.376 30.302 5.641 1.875 7.019"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-304",
    transform: "translate(486.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-51",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-303"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-302",
    mask: "url(#mask-51)",
    points: "25.302 0.641 0.405 7.271 3.64 16.873 25.302 0.641"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M481.543,52.469 C481.48,52.434 481.424,52.386 481.376,52.327 C481.179,52.079 481.221,51.718 481.469,51.521 C482.252,50.898 483.091,50.349 483.96,49.89 C484.24,49.74 484.587,49.848 484.735,50.13 C484.883,50.41 484.776,50.757 484.496,50.905 C483.688,51.331 482.911,51.84 482.183,52.419 C481.994,52.569 481.74,52.581 481.543,52.469",
    id: "Fill-305",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.399,68.279 C495.292,68.217 495.202,68.121 495.152,67.997 C495.032,67.703 495.173,67.368 495.466,67.248 C497.371,66.472 499.583,66.364 501.534,66.952 C501.836,67.045 502.01,67.363 501.918,67.668 C501.827,67.971 501.507,68.143 501.203,68.051 C499.523,67.545 497.541,67.642 495.9,68.311 C495.731,68.38 495.548,68.362 495.399,68.279 Z M505.071,75.241 C504.844,75.112 504.728,74.839 504.805,74.578 C505.209,73.221 505.142,71.951 504.603,70.8 C504.411,70.395 504.164,70.019 503.865,69.683 C503.654,69.446 503.676,69.083 503.913,68.873 C504.149,68.662 504.514,68.683 504.723,68.92 C505.095,69.339 505.404,69.807 505.641,70.312 C506.295,71.706 506.386,73.294 505.905,74.906 C505.814,75.209 505.494,75.382 505.191,75.292 C505.148,75.279 505.108,75.262 505.071,75.241 Z M476.144,59.887 C475.898,59.748 475.787,59.446 475.893,59.177 C476.226,58.332 476.62,57.506 477.064,56.722 C477.604,55.77 478.223,54.869 478.907,54.041 C479.108,53.796 479.47,53.759 479.715,53.964 C479.959,54.165 479.994,54.527 479.792,54.771 C479.151,55.548 478.569,56.395 478.063,57.288 C477.646,58.025 477.274,58.803 476.961,59.598 C476.845,59.893 476.512,60.038 476.217,59.921 C476.19,59.911 476.166,59.899 476.144,59.887 Z M488.604,74.413 C488.586,74.403 488.569,74.392 488.554,74.381 C488.295,74.197 488.234,73.839 488.418,73.581 C489.797,71.639 491.05,70.23 492.363,69.148 C492.607,68.947 492.97,68.983 493.172,69.227 C493.373,69.471 493.338,69.832 493.093,70.035 C491.86,71.05 490.673,72.388 489.354,74.245 C489.182,74.488 488.856,74.556 488.604,74.413 Z M498.887,81.792 C498.785,81.735 498.7,81.646 498.648,81.532 C498.517,81.243 498.644,80.903 498.932,80.771 C499.371,80.571 499.8,80.347 500.209,80.107 C501.369,79.425 502.428,78.501 503.27,77.435 C503.466,77.186 503.828,77.145 504.076,77.34 C504.325,77.536 504.367,77.897 504.171,78.146 C503.241,79.324 502.072,80.344 500.79,81.097 C500.349,81.357 499.884,81.599 499.408,81.815 C499.234,81.895 499.041,81.88 498.887,81.792 Z M474.964,68.992 C474.813,68.906 474.701,68.752 474.678,68.566 C474.426,66.617 474.497,64.614 474.889,62.612 C474.949,62.301 475.251,62.098 475.563,62.159 C475.874,62.219 476.076,62.522 476.015,62.832 C475.646,64.713 475.58,66.593 475.815,68.419 C475.856,68.733 475.635,69.021 475.32,69.061 C475.191,69.078 475.068,69.051 474.964,68.992 Z M489.817,83.055 C489.62,82.944 489.5,82.72 489.531,82.481 C489.573,82.167 489.86,81.946 490.175,81.987 C492.08,82.236 493.957,82.175 495.754,81.804 C496.063,81.739 496.368,81.939 496.432,82.251 C496.495,82.562 496.296,82.864 495.985,82.929 C494.063,83.325 492.058,83.391 490.026,83.125 C489.95,83.115 489.88,83.091 489.817,83.055 Z M478.717,77.321 C478.663,77.291 478.614,77.252 478.571,77.204 C477.738,76.267 477.023,75.245 476.447,74.167 C476.088,73.496 475.774,72.788 475.515,72.063 C475.407,71.764 475.563,71.435 475.86,71.329 C476.16,71.221 476.488,71.377 476.595,71.675 C476.836,72.348 477.127,73.004 477.46,73.626 C477.993,74.625 478.656,75.571 479.429,76.44 C479.64,76.678 479.618,77.041 479.382,77.25 C479.193,77.418 478.925,77.439 478.717,77.321 Z M483.688,82.276 C483.414,82.122 483.316,81.776 483.467,81.5 C483.534,81.377 483.603,81.255 483.671,81.132 C482.817,80.689 481.996,80.181 481.23,79.619 C480.976,79.431 480.92,79.072 481.108,78.816 C481.296,78.562 481.654,78.502 481.91,78.694 C482.64,79.229 483.423,79.713 484.238,80.133 C484.907,78.979 485.641,77.782 486.469,76.495 C486.64,76.228 486.999,76.152 487.262,76.322 C487.528,76.493 487.605,76.849 487.435,77.115 C486.636,78.357 485.926,79.513 485.279,80.627 C485.806,80.857 486.343,81.062 486.891,81.24 C487.197,81.343 487.356,81.664 487.258,81.964 C487.159,82.266 486.835,82.43 486.534,82.332 C485.912,82.128 485.303,81.894 484.708,81.63 C484.629,81.771 484.551,81.912 484.474,82.053 C484.32,82.331 483.972,82.432 483.694,82.28 C483.691,82.279 483.689,82.277 483.688,82.276 Z M479.968,90.761 C479.738,90.631 479.621,90.354 479.704,90.09 C480.255,88.333 480.982,86.495 481.866,84.628 C482.001,84.341 482.344,84.219 482.63,84.354 C482.907,84.48 483.039,84.832 482.903,85.119 C482.043,86.938 481.335,88.727 480.799,90.434 C480.704,90.736 480.383,90.904 480.079,90.81 C480.04,90.797 480.003,90.781 479.968,90.761 Z M478.572,99.89 C478.403,99.794 478.287,99.615 478.281,99.405 L478.276,99.127 C478.262,97.3 478.445,95.412 478.823,93.517 C478.885,93.205 479.188,93.002 479.498,93.065 C479.81,93.124 480.011,93.429 479.949,93.739 C479.587,95.56 479.41,97.369 479.425,99.116 L479.429,99.375 C479.438,99.692 479.187,99.956 478.87,99.964 C478.763,99.966 478.66,99.94 478.572,99.89 Z M480.854,108.804 C480.759,108.75 480.679,108.67 480.626,108.565 C479.723,106.793 479.066,104.907 478.677,102.956 C478.615,102.645 478.817,102.342 479.128,102.28 C479.438,102.219 479.741,102.42 479.803,102.73 C480.172,104.579 480.792,106.366 481.647,108.044 C481.792,108.327 481.681,108.672 481.397,108.816 C481.22,108.907 481.016,108.896 480.854,108.804 Z M486.88,115.726 C486.869,115.72 486.858,115.713 486.849,115.707 C485.233,114.652 483.776,113.271 482.517,111.602 C482.327,111.348 482.377,110.989 482.631,110.797 C482.884,110.606 483.243,110.66 483.435,110.91 C484.613,112.473 485.973,113.764 487.476,114.745 C487.741,114.919 487.816,115.274 487.643,115.54 C487.477,115.794 487.141,115.874 486.88,115.726 L486.88,115.726 Z",
    id: "Fill-306",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.052,117.272 C489.817,117.14 489.702,116.855 489.791,116.591 C489.892,116.29 490.216,116.129 490.518,116.229 C491.386,116.52 492.285,116.713 493.192,116.805 C493.508,116.835 493.738,117.118 493.706,117.432 C493.675,117.748 493.394,117.978 493.078,117.946 C492.087,117.847 491.103,117.636 490.152,117.318 C490.117,117.306 490.083,117.291 490.052,117.272",
    id: "Fill-307",
    fill: "#5BBDB7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardExec);
export default __webpack_public_path__ + "static/media/card-exec.58a2a79967de3bd060289bc7fd926afb.svg";
export { ForwardRef as ReactComponent };